"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QwilrPayIntegrationPrompt = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./QwilrPay.css"));
var QwilrPayIntegrationPrompt = function (_a) {
    var setIsOnboardingModalOpen = _a.setIsOnboardingModalOpen;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", className: styles.integrationPrompt, align: "center", padding: "l" },
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "3", className: styles.activateHeading }, "Activate Payments"),
        react_1.default.createElement(kaleidoscope_1.Text, { align: "center" },
            "Connect QwilrPay to get started",
            react_1.default.createElement("br", null),
            "and get paid instantly"),
        react_1.default.createElement("img", { className: styles.qPayVideoPlaceholder, src: "Assets/Images/qwilrPay/qwilr-pay-intro-video-placeholder.png" }),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", justify: "spaceAround" },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: function () { } }, "Learn More"),
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, onClick: function () {
                    setIsOnboardingModalOpen(true);
                } }, "Connect")),
        react_1.default.createElement(kaleidoscope_1.Link, { href: "#" }, "Connect an existing Stripe Account")));
};
exports.QwilrPayIntegrationPrompt = QwilrPayIntegrationPrompt;
